import get from 'lodash/get';
import fetch from 'isomorphic-fetch';

import { responseReceived } from '~/lib/mobile-x';

import { getHeaders } from '~/genericFunctions';

export const submitCalculationRequest = async ({ globalData, requestData: { formData, loanOfferData } }) => {
  const { host, protocol } = window.location;
  const requestBody = {
    loanAmountRequested: {
      amount: parseFloat(get(formData, 'requestedAmount')),
      currency: 'MXN',
    },
    ...loanOfferData,
  };
  let data, response = {};

  try {
    let url = `${protocol}//${host}/api/payment-calculation-request`;

    response = await fetch(url, {
      method: 'post',
      body: JSON.stringify(requestBody),
      headers: getHeaders({
        globalData,
      }),
    });
    responseReceived(get(response, 'status'));
  } catch (err) {
    throw new Error ('Error in POST to API submitCalculationRequest');
  }
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  data = await response.json();
  return data;
};
